<template>
  <div class="offline-indicator">
    <div class="icon">
      <font-awesome-icon icon="times" size="5x"/>
    </div>
    No data known and currently offline
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
.offline-indicator {
  text-align: center;
}
</style>
